export default __webpack_public_path__ + "static/media/weeding.55e6b77b.jpg";